import React, { useState } from 'react';
import { auth } from '../config/firebase';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import { Ic } from '../components/design/Icons';
import { useTheme } from '../components/design/ThemeContext';

const Login = () => {
  const navigate = useNavigate();
  const { theme, toggleTheme } = useTheme();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const token = await userCredential.user.getIdToken();
      localStorage.setItem('authToken', token);
      const redirectUrl = localStorage.getItem('redirectAfterLogin') || '/';
      localStorage.removeItem('redirectAfterLogin');
      navigate(redirectUrl);
    } catch (err) {
      setError('Email ou mot de passe incorrect. Veuillez réessayer.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: 'var(--bg)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: 20,
      fontFamily: 'var(--font-sans)',
      color: 'var(--ink)',
    }}>
      <div style={{
        width: '100%',
        maxWidth: 400,
        border: '1px solid var(--rule)',
        background: 'var(--bg-1)',
        padding: 48,
        position: 'relative',
      }}>
        <button
          onClick={toggleTheme}
          aria-label="Basculer thème"
          style={{
            position: 'absolute', top: 16, right: 16,
            width: 32, height: 32, display: 'grid', placeItems: 'center',
            color: 'var(--ink-3)', background: 'transparent',
            border: '1px solid transparent', cursor: 'pointer',
          }}
        >
          {theme === 'dark' ? Ic.sun : Ic.moon}
        </button>
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 40 }}>
          <img
            src="/logoMS.png"
            alt="MS"
            style={{
              width: 64, height: 64, objectFit: 'contain',
              filter: theme === 'dark' ? 'brightness(0) invert(1)' : 'none',
            }}
          />
        </div>

        <div className="eyebrow" style={{ textAlign: 'center', color: 'var(--accent)' }}>§ Authentification</div>
        <h1 style={{
          fontSize: 36,
          fontWeight: 500,
          letterSpacing: '-0.03em',
          textAlign: 'center',
          margin: '16px 0 8px',
        }}>
          TheApp
        </h1>
        <div className="mono" style={{
          textAlign: 'center',
          color: 'var(--ink-3)',
          fontSize: 11,
          letterSpacing: '0.14em',
          marginBottom: 40,
        }}>
          · MATTHIEU SIMAR · AUTO-ENTREPRENEUR
        </div>

        {error && (
          <div style={{
            marginBottom: 24,
            padding: '12px 16px',
            border: '1px solid var(--danger)',
            background: 'color-mix(in oklch, var(--danger), transparent 90%)',
            color: 'var(--danger)',
            fontSize: 13,
            fontFamily: 'var(--font-mono)',
          }}>
            {error}
          </div>
        )}

        <form onSubmit={handleLogin}>
          <div style={{ marginBottom: 24 }}>
            <label className="mono" style={{
              display: 'block',
              fontSize: 10,
              color: 'var(--ink-3)',
              letterSpacing: '0.14em',
              textTransform: 'uppercase',
              marginBottom: 8,
            }}>
              Email
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              style={{
                width: '100%',
                padding: '12px 0',
                background: 'transparent',
                border: 0,
                borderBottom: '1px solid var(--rule-2)',
                color: 'var(--ink)',
                fontSize: 14,
                outline: 'none',
                fontFamily: 'var(--font-mono)',
              }}
              placeholder="vous@exemple.com"
            />
          </div>

          <div style={{ marginBottom: 40 }}>
            <label className="mono" style={{
              display: 'block',
              fontSize: 10,
              color: 'var(--ink-3)',
              letterSpacing: '0.14em',
              textTransform: 'uppercase',
              marginBottom: 8,
            }}>
              Mot de passe
            </label>
            <div style={{ position: 'relative' }}>
              <input
                type={showPassword ? 'text' : 'password'}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                style={{
                  width: '100%',
                  padding: '12px 32px 12px 0',
                  background: 'transparent',
                  border: 0,
                  borderBottom: '1px solid var(--rule-2)',
                  color: 'var(--ink)',
                  fontSize: 14,
                  outline: 'none',
                  fontFamily: 'var(--font-mono)',
                }}
                placeholder="••••••••"
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                style={{
                  position: 'absolute',
                  right: 0,
                  top: '50%',
                  transform: 'translateY(-50%)',
                  background: 'transparent',
                  border: 0,
                  color: 'var(--ink-4)',
                  fontSize: 10,
                  cursor: 'pointer',
                  fontFamily: 'var(--font-mono)',
                  letterSpacing: '0.1em',
                }}
              >
                {showPassword ? 'MASQUER' : 'AFFICHER'}
              </button>
            </div>
          </div>

          <button
            type="submit"
            disabled={loading}
            style={{
              width: '100%',
              padding: '14px',
              background: loading ? 'var(--rule-2)' : 'var(--accent)',
              color: 'var(--bg)',
              border: 0,
              fontFamily: 'var(--font-mono)',
              fontSize: 12,
              letterSpacing: '0.16em',
              textTransform: 'uppercase',
              cursor: loading ? 'not-allowed' : 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 8,
            }}
          >
            {loading ? 'CONNEXION…' : 'SE CONNECTER →'}
          </button>
        </form>

        <div className="mono" style={{
          marginTop: 40,
          textAlign: 'center',
          fontSize: 10,
          color: 'var(--ink-4)',
          letterSpacing: '0.14em',
        }}>
          v2.0 · GRID TECHNICAL · 2026
        </div>
      </div>
    </div>
  );
};

export default Login;
